import { ListRequest, GenericResponse, BaseResponse } from "@/common/common_utils";
import { axiosInstance } from "@/services/axios.service";
import { ENDPOINTS } from "@/constants/endpoints";

export interface BudgetRequest {
	id: string;
	date: string;
	amount: string;
	status: string;
	reason: string;
	action?: {
		user: string;
		date: string;
	};
}

export interface BudgetRequestDto {
	Id: number;
	UserId?: number;
	ApproverId?: number;
	ApproverFullName?: string;
	Amount?: number;
	Reason?: string;
	DateRequested?: Date;
	DateApprovedDeclined?: Date;
	Status?: string;
}

export interface GetBudgetRequestListRequest extends ListRequest {
}


export const approveBudgetRequest = async (budgetRequestId: number): Promise<BaseResponse> => {
	const result = await axiosInstance.post<BaseResponse>(
		ENDPOINTS['/api/Budget/ApproveBudgetRequest'],
		{ Id: budgetRequestId }
	);
	return result.data;
};

export const declineBudgetRequest = async (budgetRequestId: number): Promise<BaseResponse> => {
	const result = await axiosInstance.post<BaseResponse>(
		ENDPOINTS['/api/Budget/DeclineBudgetRequest'],
		{ Id: budgetRequestId }
	);
	return result.data;
};
